export const MAX_DEPOSIT_PERCENTAGE = 0.9;
export const MIN_DEPOSIT_PERCENTAGE_FOR_HIGH_COST = 0.05;
export const DEPOSIT_ERROR_MAX = 'max';
export const DEPOSIT_ERROR_MIN = 'min';

const EPSILON = 1e-9;

function toNumber(value) {
  const number = parseFloat(value);
  return isNaN(number) ? 0 : number;
}

/**
 * Porcentaje exacto (decimal) que representa un monto de enganche sobre el costo del proyecto.
 */
export function depositPercentageFromAmount(amount, totalCost) {
  const cost = toNumber(totalCost);
  const deposit = toNumber(amount);

  if (cost <= 0 || deposit <= 0) {
    return 0;
  }

  return deposit / cost;
}

/**
 * Monto en pesos (a centavos) que representa un porcentaje (decimal) de enganche.
 */
export function depositAmountFromPercentage(percentage, totalCost) {
  return Math.round(toNumber(totalCost) * toNumber(percentage) * 100) / 100;
}

/**
 * Opción del selector más cercana al porcentaje indicado.
 */
export function closestDepositOption(options, percentage) {
  return options.reduce((closest, option) => {
    return Math.abs(option.value - percentage) < Math.abs(closest.value - percentage) ? option : closest;
  });
}

/**
 * Valida un enganche capturado libremente. Regresa el código del error o null si es válido.
 */
export function validateDepositPercentage(percentage, totalCost, costWithRequiredDeposit) {
  if (toNumber(totalCost) <= 0) {
    return null;
  }

  if (percentage > MAX_DEPOSIT_PERCENTAGE + EPSILON) {
    return DEPOSIT_ERROR_MAX;
  }

  if (toNumber(totalCost) >= toNumber(costWithRequiredDeposit)
      && percentage < MIN_DEPOSIT_PERCENTAGE_FOR_HIGH_COST - EPSILON) {
    return DEPOSIT_ERROR_MIN;
  }

  return null;
}
